import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { LoggedInUserService } from './logged.in.user';
import { IRouteAuthConfiguration } from './permission';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private user: LoggedInUserService) {
    }

    canActivate(routeSnapshot: ActivatedRouteSnapshot) {
        //If it's a valid cast, cast it, or else set to null
        const routeAuthConfig = routeSnapshot.data &&
            (routeSnapshot.data.hasOwnProperty('requiresEntityPermissions') || routeSnapshot.data.hasOwnProperty('requiresAdHocPermissions'))
            ? routeSnapshot.data as IRouteAuthConfiguration
            : null;

        if (this.user && this.user.getCurrentUser() && this.user.getCurrentUser().canActivate(routeAuthConfig)) {
            return true;
        }

        //Don't have permission so redirect to login
        this.router.navigate(['/account/login']);
        return false;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/auth/auth.guard.ts